export default class User {
    constructor(o){
        Object.assign(this,o);
    }
}


// WEBPACK FOOTER //
// src/models/User.js